import { QueryClient, QueryClientProvider } from '@tanstack/react-query';
import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import { BrowserRouter } from 'react-router';
import { Toaster } from 'sonner';

import { App } from './App';
import { ApiError } from './api';
import './index.css';
import { BASENAME, SPACE_LABEL } from './lib/space';

// The server serves this app under /{space}/manage only; the dev server serves it anywhere.
if (!window.location.pathname.startsWith(BASENAME)) window.location.replace(`${BASENAME}/`);
document.title = `${SPACE_LABEL} · Mock Sensors`;

const prefersDark = window.matchMedia('(prefers-color-scheme: dark)');
const applyTheme = () => document.documentElement.classList.toggle('dark', prefersDark.matches);
applyTheme();
prefersDark.addEventListener('change', applyTheme);

const queryClient = new QueryClient({
	defaultOptions: {
		queries: {
			staleTime: 5_000,
			retry: (count, err) => !(err instanceof ApiError && err.status < 500) && count < 2,
		},
	},
});

createRoot(document.getElementById('root')!).render(
	<StrictMode>
		<QueryClientProvider client={queryClient}>
			<BrowserRouter basename={BASENAME}>
				<App />
				<Toaster richColors position="bottom-right" />
			</BrowserRouter>
		</QueryClientProvider>
	</StrictMode>,
);
